module.exports = __webpack_public_path__ + "img/image5.e983a682.jpg";